import { Header } from "@/components/layout/Header";
import { Account } from "@/components/user/account/ui/Account";

export const AccountPage = () => {
	return (
		<div className="overflow-y-scroll h-full">
			<Header />

			<Account />
		</div>
	);
};
